import {observable} from "mobx";
import {RelatorioService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";
import fileDownload from "../../comum/components/FileDownload";

export default class FinanceiroStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.relatorioService = new RelatorioService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.relatorioService.findFinanceiro(filtro).then(response => {
            this.dados = response.data;

            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    onExportExcel = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.relatorioService.downloadFinanceiroExcel(filtro).then(response => {
            fileDownload(response.data, "Relatório financeiro.xlsx");

            this.carregando = false;
        }).catch(error => {
            this.erro = "Nenhum resultado encontrado";
            this.carregando = false;
        });
    }

}
